import React, { Component } from 'react';
import { connect } from 'react-redux';
import { calculatePrice, Packages, Services } from '../config/appConfig';
import M from "materialize-css";


class Book extends Component {
    state = {
        bookingType: Object.keys(Services)[0],
        duration: Object.keys(Services[Object.keys(Services)[0]].serviceTime)[0],
        date: new Date(Date.now() + 24*60*60*1000),
        package: Object.keys(Packages)[1]
    }
    componentDidMount() {
        M.AutoInit();
    }

    render() {
        return (
            
            <div className="container">
                <br/>
                <form className='white'
                    onSubmit={e => {
                        e.preventDefault();
                        this.props.createBooking(this.state);
                    }}
                >
                    <div className="row">
                        <div className="input-field col s3"><span style={labelStyle}>Service Request</span></div>
                        <div className="input-field col s9">
                            <select
                                id="bookingType" className='browser-default'
                                onChange={e => this.setState({ bookingType: e.target.value, duration: '' })}
                                value={this.state.bookingType}
                            >
                                {
                                    Object.keys(Services).map(type => (
                                        <option value={type} key={type}>{Services[type].display}</option>))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s3"><span style={labelStyle}>Select Date and Time of Booking</span></div>
                        <div className="input-field col s5">
                            <input
                                id="date" className='datepicker browser-default'
                                onChange={e => this.setState({ date: e.target.value })}
                                value={this.state.date.toDateString()}
                            >
                            </input>
                        </div>
                        <div className="input-field col s4">
                            <input
                                id="date" className='timepicker browser-default'
                                onChange={e => this.setState({ date: e.target.value })}
                                value={this.state.date.toLocaleTimeString()}
                            >
                            </input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s3"><span style={labelStyle}>Duration and Frequency</span></div>
                        <div className="input-field col s9">
                            <select
                                id="duration" className='browser-default'
                                onChange={e => this.setState({ duration: e.target.value })}
                                value={this.state.duration}
                            >
                                <option value={''} key={''}></option>
                                {
                                    Object.keys(Services[this.state.bookingType].serviceTime).map(duration => (
                                        <option value={duration} key={duration}>{Services[this.state.bookingType].serviceTime[duration].display}</option>))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s3"><span style={labelStyle}>Package Deal</span></div>
                        <div className="input-field col s9">
                            <select
                                id="package" className='browser-default'
                                onChange={e => this.setState({ package: e.target.value })}
                                value={this.state.package}
                            >
                                {
                                    Object.keys(Packages).map(packageType => (
                                        <option value={packageType} key={packageType}>{Packages[packageType].display}</option>))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s3"><span style={labelStyle}>Estimated Charge **</span></div>
                        <div className="input-field col s9 left-align">
                            <span style={priceStyle}>{'₹' + (Math.round(calculatePrice(this.state.bookingType, this.state.duration, this.state.package) * 100) / 100).toFixed(2)  + ' /day'}</span>
                        </div>
                    </div>
                    <div className="row">
                        <span style={tcStyle}>** Actual charge may be diffrent from estimated charge depending on travelling cost, working load and other factors. See FAQ for more details.</span>
                    </div>
                    <br/>
                    <div className="row">
                        <button type="submit" className="btn btn-large green">
                            Submit
                        </button>
                    </div>
                    <br/>

                </form>
            </div>
        );
    }
}

const labelStyle = { marginTop: 55, fontFamily: "Roboto", fontSize: 20 }
const priceStyle = { marginTop: 55, fontFamily: "Roboto", fontSize: 25, fontWeight: 'bold', background: 'white' }
const tcStyle = { marginTop: 55, fontFamily: "Roboto", fontSize: 12 }


const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Book);
